{
	"failedRetryPublish": "Failed to retry publish. Please try again later.",
	"publishFailedMessage": "Publish failed due to a network connectivity error. Please check your internet connection and try again.",
	"publishFailedTitle": "Publish Failed",
	"publishCanceledTitle": "Publish to Pixieset Canceled",
	"publishCompleteTitle": "Publish to Pixieset Complete",
	"publishIncompleteTitle": "Publish Incomplete",
	"trainMyAiStyle": "Train My AI Style",
	"viewOnPixieset": "View on Pixieset"
}
